import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface SpinnerProps {
    text?: string;
    errorMessage?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ text, errorMessage }) => {
    return (
        <div className="spinner-container">
            {errorMessage ? (
                <span className="error-icon">
                    <FontAwesomeIcon icon={faExclamationTriangle} />
                </span>
            ) : (
                <span className="spinner" />
            )}
            {(errorMessage || text) && (
                <span className="spinner-text">
                    {errorMessage ? errorMessage : text}
                </span>
            )}
        </div>
    );
};

export default Spinner;
